<template>
  <v-row dense>
    <v-col cols="12">
      <app-title :texto="titulo.toUpperCase()" />
    </v-col>
    <v-col cols="12">
      <v-data-table
        :items="diagnosticosView"
        :headers="headers"
        :search="opcoes.pesquisa"
        :sort-by="opcoes.ordenarPor"
        :sort-desc="opcoes.decrescente"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:top>
          <v-row dense>
            <v-col
              cols="12"
              md="4"
            >
              <app-sort v-model="opcoes" />
            </v-col>
            <v-col
              cols="0"
              md="4"
            />
            <v-col
              cols="12"
              md="4"
            >
              <app-search v-model="opcoes" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.inicioDesempenho`]="{ item }">
          {{ item.inicioDesempenho | date }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <v-chip
            class="pa-2"
            :color="item.situacao.cor"
            small
            outlined
          >
            <v-avatar left>
              <v-icon>{{ item.situacao.icone }}</v-icon>
            </v-avatar>
            {{ item.situacao.nome }}
          </v-chip>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.situacao.id === 'AGENDADO' || item.situacao.id === 'ATIVO'"
                  icon
                  small
                  color="secondary"
                  class="mr-2"
                  v-on="on"
                  @click="editar(item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para editar o diagnóstico</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.situacao.id === 'AGENDADO'"
                  icon
                  small
                  color="error"
                  v-on="on"
                  @click="confirmDelete(item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para excluir o diagnóstico</span>
            </v-tooltip>
          </v-col>
        </template>
      </v-data-table>
    </v-col>

    <dialog-remove
      v-show="dialogs.dialogRemove.visible"
      :confirm-action="deleteDiagnostico"
      :dialog-visible="dialogs.dialogRemove.visible"
      :toogle-visible="toogleDialogRemove"
      descricao="Você realmente deseja excluir esse diagnóstico"
    />
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import DialogRemove from '@/components/DialogRemove';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const diagnosticoRepository = RepositoryFactory.get('diagnostico');

export default {
  name: 'DiagnosticoList',

  components: {
    AppTitle, AppSort, AppSearch, DialogRemove,
  },

  props: {
    titulo: {
      type: String,
      default: 'HISTÓRICO DE DIAGNÓSTICOS',
      required: false,
    },
    modo: {
      type: String,
      default: 'VISUALIZACAO',
      required: false,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'NOME', align: 'start', value: 'nome', sortable: false,
        },
        {
          text: 'MAPEAMENTO ASSOCIADO', value: 'mapeamento.nome', sortable: false, width: '15%', align: 'center',
        },
        {
          text: 'INÍCIO', value: 'inicio', sortable: false, width: '10%', align: 'center',
        },
        {
          text: 'FIM', value: 'fim', sortable: false, width: '10%', align: 'center',
        },
        {
          text: 'INÍCIO DO DESEMPENHO', value: 'inicioDesempenho', sortable: false, width: '10%', align: 'center',
        },
        {
          text: 'SITUAÇÃO', value: 'situacao', sortable: false, width: '10%', align: 'center',
        },
        {
          text: 'AÇÕES', value: 'acoes', sortable: false, width: '15%', align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Nome' },
        lista: [
          { id: 'nome', descricao: 'Nome' },
          { id: 'mapeamento.nome', descricao: 'Mapeamento Associado' },
          { id: 'inicio', descricao: 'Início' },
          { id: 'fim', descricao: 'Fim' },
          { id: 'inicioDesempenho', descricao: 'Início do Desempenho' },
          { id: 'situacao.ordem', descricao: 'Situação' },
        ],
      },
      dialogs: {
        dialogRemove: { visible: false, item: null },
      },
    };
  },

  computed: {
    ...mapState({
      diagnosticos: (state) => state.diagnostico.diagnosticosComissao,
    }),
    diagnosticosView() {
      return this.diagnosticos.map((m) => ({
        ...m,
        inicio: this.getInicioDiagnostico(m),
        fim: this.getFimDiagnostico(m),
        situacao: this.getSituacaoDiagnostico(m),
      }));
    },
    isEdicao() {
      return this.modo === 'EDICAO';
    },
  },

  methods: {
    editar(item) {
      this.$emit('update', item);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    getInicioDiagnostico(diagnostico) {
      if (Data.compare(
        'isBefore',
        { a: diagnostico.inicioComportamental, b: diagnostico.inicioResponsabilidadeChefia },
      )) {
        return Data.format(diagnostico.inicioComportamental);
      }
      return Data.format(diagnostico.inicioResponsabilidadeChefia);
    },
    getFimDiagnostico(diagnostico) {
      if (Data.compare(
        'isAfter',
        { a: diagnostico.fimComportamental, b: diagnostico.fimResponsabilidadeServidor },
      )) {
        return Data.format(diagnostico.fimComportamental);
      }
      return Data.format(diagnostico.fimResponsabilidadeServidor);
    },
    getSituacaoDiagnostico(diagnostico) {
      if (Data.compare('isAfter', { b: diagnostico.fimComportamental })
        && Data.compare('isAfter', { b: diagnostico.fimResponsabilidadeServidor })) {
        return {
          id: 'FINALIZADO',
          nome: 'Finalizado',
          ordem: 3,
          icone: 'check_circle',
          cor: 'success',
        };
      } if (Data.compare('isBefore', { b: diagnostico.inicioComportamental })
        && Data.compare('isBefore', { b: diagnostico.inicioResponsabilidadeChefia })) {
        return {
          id: 'AGENDADO',
          nome: 'Agendado',
          ordem: 1,
          icone: 'alarm',
          cor: 'grey',
        };
      }
      return {
        id: 'ATIVO',
        nome: 'Ativo',
        ordem: 2,
        icone: 'wifi_protected_setup',
        cor: 'secondary',
      };
    },
    confirmDelete(item) {
      this.dialogs.dialogRemove.item = item;
      this.toogleDialogRemove();
    },
    toogleDialogRemove() {
      this.dialogs.dialogRemove.visible = !this.dialogs.dialogRemove.visible;
      if (!this.dialogs.dialogRemove.visible) {
        this.dialogs.dialogRemove.item = {};
      }
    },
    deleteDiagnostico() {
      this.$emit('resetForm', true);
      if (this.dialogs.dialogRemove.item.id) {
        diagnosticoRepository.delete(this.dialogs.dialogRemove.item.id)
          .then((response) => {
            const index = this.diagnosticos.findIndex((d) => d.id === this.dialogs.dialogRemove.item.id);
            if (index !== -1) {
              this.diagnosticos.splice(index, 1);
            }
            this.toogleDialogRemove();
            this.$store.dispatch('app/success', {
              response,
              message: 'Diagnóstico excluído com sucesso!',
            });
          });
      }
    },
  },
};
</script>
